export type Collection = {
  id: string;
  issue: string;
  title: string;
  summary: string;
  tags: string[];
  cover: string;
  readTime: string;
};

export type Channel = {
  id: string;
  rank: string;
  name: string;
  handle: string;
  platform: string;
  summary: string;
  focus: string;
};

export type WatchRoute = {
  id: string;
  step: string;
  title: string;
  summary: string;
  icon: string;
};

export type IndexEntry = {
  id: string;
  label: string;
  count: string;
  hint: string;
};

export const issueMeta = {
  brand: "吃瓜爆黑料",
  issue: "第 2026-09 期",
  date: "2026 年 9 月 17 日 · 周四",
  slogan: "一本帮你找到「在哪看」的导航合辑",
};

export const heroStats = [
  { id: "s1", value: "128", label: "已收录账号与频道" },
  { id: "s2", value: "46", label: "本月精选合辑" },
  { id: "s3", value: "每日", label: "导航页更新频率" },
  { id: "s4", value: "7", label: "条主观看路径" },
];

export const tickerItems = [
  "本期新收录 9 个主页入口",
  "「爆料时间线」合辑已更新至第九版",
  "账号档案库新增 12 条频道说明",
  "观看路径页重新整理了渠道顺序",
  "旧事重提合集补充了两条早期线索",
  "速查索引支持按平台与题材双向定位",
];

export const collections: Collection[] = [
  {
    id: "c1",
    issue: "合辑 07",
    title: "爆料时间线：从第一张图到最新一条",
    summary:
      "把分散在各个主页里的时间点拉成一条线，按发生顺序重排，先看什么、后看什么一眼就明白，不用再翻满屏的转发。",
    tags: ["时间线", "整理向"],
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20editorial%20cover%20art%20of%20stacked%20torn%20paper%20strips%20in%20crimson%20cream%20and%20mustard%2C%20vertical%20timeline%20lines%2C%20risograph%20grain%20texture%2C%20minimal%20collage%20poster%2C%20dramatic%20negative%20space%2C%20no%20readable%20text&width=900&height=1200&seq=cgbhl-col-01&orientation=portrait",
    readTime: "8 分钟",
  },
  {
    id: "c2",
    issue: "合辑 06",
    title: "账号档案：谁在更新、更新什么",
    summary:
      "把常被问到的账号按题材归到同一册档案里，写清楚它主攻什么、更新节奏怎样，找号不再靠别人转述。",
    tags: ["账号档案", "索引向"],
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20editorial%20cover%20art%20with%20concentric%20archive%20rings%20and%20round%20stamp%20shapes%20in%20deep%20red%20on%20cream%20paper%2C%20risograph%20grain%20texture%2C%20vintage%20filing%20cabinet%20mood%2C%20minimal%20collage%20poster%2C%20no%20readable%20text&width=900&height=1200&seq=cgbhl-col-02&orientation=portrait",
    readTime: "6 分钟",
  },
  {
    id: "c3",
    issue: "合辑 05",
    title: "直播切片去哪补：按渠道排好序",
    summary:
      "错过直播又想补上的人最多，这一册把不同渠道的切片入口按清晰度和完整度排了顺序，照着走就行。",
    tags: ["观看渠道", "补课向"],
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20editorial%20cover%20art%20of%20fragmented%20screen%20rectangles%20and%20glitch%20blocks%20in%20crimson%20and%20ink%20black%20on%20warm%20paper%2C%20risograph%20grain%20texture%2C%20cinematic%20collage%20poster%2C%20no%20readable%20text&width=900&height=1200&seq=cgbhl-col-03&orientation=portrait",
    readTime: "5 分钟",
  },
  {
    id: "c4",
    issue: "合辑 04",
    title: "旧事重提：被翻出来的早期线索",
    summary:
      "新瓜往往接得上旧事。这里把被重新提起的早期内容做了索引，标出出处年份，读起来不至于断档。",
    tags: ["回溯", "文献向"],
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20editorial%20cover%20art%20of%20layered%20vintage%20newspaper%20clippings%20in%20sepia%20and%20crimson%2C%20folded%20paper%20geometry%2C%20risograph%20grain%20texture%2C%20nostalgic%20minimal%20collage%20poster%2C%20no%20readable%20text&width=900&height=1200&seq=cgbhl-col-04&orientation=portrait",
    readTime: "9 分钟",
  },
  {
    id: "c5",
    issue: "合辑 03",
    title: "辟谣与反转：哪些说法已经过时",
    summary:
      "同一件事往往流传好几个版本。这一册专门记录被更正、被推翻的说法，避免拿着过期结论继续往下聊。",
    tags: ["辟谣", "对照片"],
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20editorial%20cover%20art%20with%20two%20mirrored%20shapes%20splitting%20apart%20in%20crimson%20and%20sage%20green%20on%20cream%20paper%2C%20risograph%20grain%20texture%2C%20tension%20and%20balance%2C%20minimal%20collage%20poster%2C%20no%20readable%20text&width=900&height=1200&seq=cgbhl-col-05&orientation=portrait",
    readTime: "7 分钟",
  },
  {
    id: "c6",
    issue: "合辑 02",
    title: "本月新号：刚冒头的主页入口",
    summary:
      "给愿意尝鲜的人准备的一册。列出近期开始稳定更新的新主页，附一句它目前最值得看的地方。",
    tags: ["新号", "尝鲜向"],
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20editorial%20cover%20art%20of%20a%20blank%20magazine%20cover%20with%20bold%20crimson%20circle%20and%20mustard%20ribbon%20on%20warm%20paper%2C%20risograph%20grain%20texture%2C%20fresh%20minimal%20poster%2C%20no%20readable%20text&width=900&height=1200&seq=cgbhl-col-06&orientation=portrait",
    readTime: "4 分钟",
  },
];

export const channels: Channel[] = [
  {
    id: "h1",
    rank: "01",
    name: "瓜田观测站",
    handle: "@guatian_obs",
    platform: "主页频道",
    summary: "每天上午整理前一天的重点，条目短、带原始出处，适合从零开始补进度。",
    focus: "每日速览",
  },
  {
    id: "h2",
    rank: "02",
    name: "黑料档案馆",
    handle: "@archive_heile",
    platform: "合集主页",
    summary: "按人物与事件编号归档，年份标得清楚，想往回翻旧内容时最先想到它。",
    focus: "长线归档",
  },
  {
    id: "h3",
    rank: "03",
    name: "深夜爆料台",
    handle: "@night_leak",
    platform: "直播切片",
    summary: "以直播形式跟进，事后会把切片按时间顺序放好，错过直播也能补上。",
    focus: "直播跟进",
  },
  {
    id: "h4",
    rank: "04",
    name: "反转记录本",
    handle: "@reverse_note",
    platform: "对照频道",
    summary: "专门盯被更正的旧说法，一条条标出前后差异，聊天前先看一眼不容易踩坑。",
    focus: "更正对照",
  },
  {
    id: "h5",
    rank: "05",
    name: "关键词收容所",
    handle: "@kw_shelter",
    platform: "索引主页",
    summary: "把散落的关键词与人名做成一页索引，顺着词点进去就能找到对应内容。",
    focus: "关键词索引",
  },
  {
    id: "h6",
    rank: "06",
    name: "路口指 Northe",
    handle: "@crossroad_n",
    platform: "导航主页",
    summary: "本身不生产内容，只负责把能看的地方排好顺序，适合完全不知道从哪开始的人。",
    focus: "入口导航",
  },
];

export const watchRoutes: WatchRoute[] = [
  {
    id: "w1",
    step: "第一步",
    title: "先从合辑索引定方向",
    summary: "不急着点进任何一个主页，先在索引册里挑一本主题最接近你关心的那一册。",
    icon: "ri-book-2-line",
  },
  {
    id: "w2",
    step: "第二步",
    title: "用账号档案核对更新方",
    summary: "确认想看的内容由谁在更新，避开已经停更很久、只剩转发的入口。",
    icon: "ri-file-user-line",
  },
  {
    id: "w3",
    step: "第三步",
    title: "按渠道顺序补齐切片",
    summary: "直播与切片按完整度排序，从最完整的那条开始，不容易看到一半就断了。",
    icon: "ri-live-line",
  },
  {
    id: "w4",
    step: "第四步",
    title: "回到速查索引确认结论",
    summary: "信息有更替时，用速查索引对一遍最新说法，再决定要不要继续往深里看。",
    icon: "ri-search-eye-line",
  },
];

export const indexEntries: IndexEntry[] = [
  { id: "i1", label: "最新爆料主页", count: "24 个入口", hint: "按更新时间排序" },
  { id: "i2", label: "直播与切片频道", count: "18 个入口", hint: "含回放与切片" },
  { id: "i3", label: "账号与主页档案", count: "128 条说明", hint: "含更新节奏" },
  { id: "i4", label: "旧内容回溯索引", count: "63 条线索", hint: "标出年份出处" },
  { id: "i5", label: "辟谣与更正", count: "41 条对照", hint: "前后版本对照" },
  { id: "i6", label: "导航与合集总表", count: "9 张大表", hint: "一页看全" },
];

export const readerNotes = [
  {
    id: "n1",
    from: "读者 阿柚",
    text: "以前每次都要在群里问在哪看，现在直接打开这一页按合辑翻，省了很多来回问人的事。",
  },
  {
    id: "n2",
    from: "读者 老陈",
    text: "最喜欢账号档案那部分，写清楚了谁在更新，不会点进去发现已经停更半年了。",
  },
  {
    id: "n3",
    from: "读者 小满",
    text: "辟谣和反转那一册挺有用，聊之前先对一下，免得拿着过期的说法到处讲。",
  },
];